import { render, staticRenderFns } from "./empList.vue?vue&type=template&id=886c6d70"
import script from "./empList.vue?vue&type=script&lang=js"
export * from "./empList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports